import { useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { BackdropDialog } from '../../../../components/shared/backdrop/BackdropDialog';
import { Page } from '../../../../components/shared/page/Page';
import { useCreateMultipleChoiceAssessmentAttempt } from '../../../../features/assessments/api/useMultipleChoiceAssessments';
import { MultipleChoiceAssessmentAttemptResult } from '../../../../features/assessments/components/multiple-choice-assessment-attempt-result/MultipleChoiceAssessmentAttemptResult';
import { MultipleChoiceAssessmentAttempt } from '../../../../features/assessments/components/multiple-choice-assessment-attempt/MultipleChoiceAssessmentAttempt';
import { useAttemptMode } from '../../../../features/assessments/useAttemptMode';

function MultipleChoiceAssessmentAttemptResultPage() {
  const { subjectId, id } = useParams();
  const navigate = useNavigate();

  const attemptMode = useAttemptMode(subjectId!);

  const [selectedAssessmentId, setSelectedAssessmentId] = useState<string>();

  const { mutateAsync: createMultipleChoiceAssessmentAttempt } =
    useCreateMultipleChoiceAssessmentAttempt();

  return (
    <Page>
      <MultipleChoiceAssessmentAttemptResult
        subjectId={subjectId!}
        assessmentAttemptId={id as string}
        onRetry={(assessmentId: string) =>
          setSelectedAssessmentId(assessmentId)
        }
      />
      <BackdropDialog open={selectedAssessmentId !== undefined}>
        <MultipleChoiceAssessmentAttempt
          mode={attemptMode}
          onStart={(mode) =>
            createMultipleChoiceAssessmentAttempt({
              subjectId: subjectId!,
              assessmentId: selectedAssessmentId!,
              mode,
            })
          }
          onFinish={(attempt) => {
            setSelectedAssessmentId(undefined);
            navigate(
              `/materia/${subjectId}/simulacros/mc/resultados/${attempt.id}`,
            );
          }}
          onClose={() => setSelectedAssessmentId(undefined)}
        />
      </BackdropDialog>
    </Page>
  );
}

export { MultipleChoiceAssessmentAttemptResultPage };
